import { TextInput } from '@components/form';
import posthog from 'posthog-js';
import { useState } from 'react';
import { useDebounce } from 'react-use';

export const Search = ({
  onSearch,
  placeholder = 'Search by name, description, or tags',
  context,
}: {
  onSearch: (searchText: string) => void;
  placeholder?: string;
  context: string;
}) => {
  const [searchText, setSearchText] = useState('');
  useDebounce(
    () => {
      onSearch(searchText);
      posthog.capture('user_search', { type: 'search', context, searchString: searchText });
    },
    400,
    [searchText],
  );
  return (
    <TextInput
      fullWidth
      placeholder={placeholder}
      onChange={(e) => setSearchText(e.target.value)}
    />
  );
};
